import { Deserializer } from "jsonapi-serializer";
import { genericError } from "../models/GenericError";
import { ListQuery } from "../models/ListQuery";
import { Name } from "../models/Name";
import { PaginationModel } from "../models/Pagination";
import { apiConnector } from "./presetService";
import { createPagination } from "./utilities/paginationBuilder";
import { getConstraintViolation, processServerError } from "./utilities/ServiceError";
import { createPartialURL, getFilterClause } from "./utilities/urlBuilder";

export const getAllDeviceNamesWithPagination = async (listParameters?: ListQuery): Promise<{ rows: Name[], pagination: PaginationModel }> => {
    try {
       
        let filter: string = getFilterClause(listParameters?.filters, listParameters?.searchTerm);
        filter = filter.replace('typeId', 'hdtName');
        const partialURL = createPartialURL(listParameters?.goToPage, listParameters?.pageSize, listParameters?.sortBy, filter);
        const url = `hwDeviceType?fields[hwDeviceType]=hdtName${partialURL}`;
        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const pagination = createPagination(json.meta)

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }

            new Deserializer().deserialize(json, (error: any, data: any[]) => {
                if (error) {
                    return reject({status: response.status, message: genericError });
                }

                const deviceNames: Name[] = data.map(deviceNames => {
                    return {
                        value: deviceNames['id'],
                        label: deviceNames['hdt-name'],
                    }
                })

                return resolve({ rows: deviceNames, pagination: pagination });
            })
        });
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}

export const getCloudEnabledControllers = async (listParameters?: ListQuery): Promise<{ rows: Name[], pagination: PaginationModel }> => {
    try {
        const url = '';

        const headers = {
            type: "controllerCloudEnabled",
            tableName: 'unitType',
        }

        const response = await apiConnector.fetchData(url, true, headers);
        const jsonResponse = await response.json();

        return new Promise((resolve, reject) => {
            if (jsonResponse.errors) {
                return reject({ status: response.status, message: genericError });
            }

            const controllers: Name[] = jsonResponse.map((controller: any) => {
                return {
                    value: controller['unitTypeId'],
                    label: controller['unitTypeName'] + ' (' + controller['unitTypeDescOriginal'] + ')',
                }
            })

            return resolve({ rows: controllers, pagination: { maxPageSize: 7, pageNumber: 1, totalCount: 0, totalPages: 1, sizes: [7, 50, 100], pages: [1] }});
        });
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}
